<template>
  <ul class="products container">
    <li
      v-for="(product, index) in products"
      :key="product.id"
      :class="{
        'product--full-width': fullWidthTile(index),
        'product--video': videoTile(index),
      }"
    >
      <VideoTile
        v-if="videoTile(index) && hasVideo(product)"
        :product="product"
        :video="product.editorialMedia?.reference"
      />

      <PhotoTile
        v-else-if="videoTile(index) && !hasVideo(product)"
        :product="product"
        use-editorial-photo
      />

      <PhotoTile v-else :product="product" :flat-lays="flatLays" />
    </li>
  </ul>
</template>

<script>
import PhotoTile from "@/components/PhotoTile.vue";
import VideoTile from "@/components/VideoTile.vue";

const fullWidthDesktopIndexes = [0, 5, 14];
const fullWidthMobileIndexes = [0, 3, 4, 5, 8, 11, 12, 15, 16];

const videoDesktopIndexes = [0, 5, 14];
const videoMobileIndexes = [0, 4, 8, 11, 15];

export default {
  name: "ProductGrid",
  components: {
    PhotoTile,
    VideoTile,
  },
  inject: ["mq"],
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showOnePhoto: {
      type: Boolean,
      default: false,
    },
    flatLays: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    fullWidthTile(index) {
      if (this.mq.mdPlus) {
        if (fullWidthDesktopIndexes.includes(index)) {
          return true;
        }

        return false;
      }

      if (fullWidthMobileIndexes.includes(index)) {
        return true;
      }

      return false;
    },
    videoTile(index) {
      if (this.mq.mdPlus) {
        if (videoDesktopIndexes.includes(index)) {
          return true;
        }

        return false;
      }

      if (videoMobileIndexes.includes(index)) {
        return true;
      }

      return false;
    },
    hasVideo(product) {
      if (product.editorialMedia?.reference?.mediaContentType === "VIDEO") {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.products {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  .product--full-width {
    grid-column: 1 / 3;
  }

  .product--landscape {
    aspect-ratio: 16/9;
    overflow: hidden;
  }

  @include respond-above(md) {
    padding: 0 20px;
    grid-template-columns: repeat(4, 1fr);
    margin-bottom: 0;
    .product--full-width {
      grid-column: 1 / 5;
    }
  }

  &.container {
    @include respond-below(md) {
      padding: 0;
    }
  }

  ::v-deep(.product__info) {
    @include respond-above(md) {
      padding-bottom: 120px;
    }
  }
}
</style>
